// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__3m9bG","image":"NotFound_image__ZAWbc","title":"NotFound_title__uO8Xc"};